import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { TipoSolapaAutorizacion } from 'src/app/shared/enums/TipoSolapaAutorizacion';
import { TipoUsuario } from 'src/app/shared/enums/tipoUsuario';

@Component({
  selector: 'app-matriculas-index',
  templateUrl: './matriculas-index.component.html',
  styleUrls: ['./matriculas-index.component.scss']
})
export class MatriculasIndexComponent implements OnInit {

  TipoUsuario = TipoUsuario;
  TipoSolapaAutorizacion = TipoSolapaAutorizacion;

  constructor(private authService : AuthService) { }

  ngOnInit(): void {
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
